import { css } from 'styled-components';
export default css `
  &::-webkit-scrollbar-track {
    background-color: none;
  }

  &::-webkit-scrollbar {
    background-color: none;
    height: var(--scrollbar-width, 10px);
    width: var(--scrollbar-width, 10px);
  }

  &::-webkit-scrollbar-thumb {
    background-color: #9c9fa1;
    border-radius: calc(var(--scrollbar-width, 10px) / 2);
    cursor: pointer;
  }
`;
